export enum DeviceType {
    Device_Unknown = 0x00,
    Device_TKLLog_RF = 0x11,
    Device_TKLLog_SAT = 0x14,
    Device_TKLLog_NBIOT = 0x15,
    Device_TKLLog_LORAWAN = 0x16,
}

//-------------------------------------------------------------------------------------------------
export function deviceName(deviceType: DeviceType): string {
    // prettier-ignore
    switch (deviceType) {
        case DeviceType.Device_TKLLog_RF      : return 'RF';
        case DeviceType.Device_TKLLog_SAT     : return 'SAT';
        case DeviceType.Device_TKLLog_NBIOT   : return 'NB IoT';
        case DeviceType.Device_TKLLog_LORAWAN : return 'LoRaWAN';
        default                               : return 'Unknown';
    }
}

//=================================================================================================
export interface IDevice {
    device_id: number;
}
export interface Device extends IDevice {
    node_id: number;
}

export interface DeviceInfo extends Device {
    info: Record<string, any>;
}

export const deviceOrderColumns = ['device_id'];
